import React from 'react';

interface Props {
  comment: string;
  onClose: () => void;
}

export default function ExplanationModal({ comment, onClose }: Props) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <p className="modal-comment">{comment}</p>
        <button className="modal-close-btn" onClick={onClose}>閉じる</button>
      </div>
    </div>
  );
}
